<input type="hidden" [name]="name" [value]="value ?? ''" />
